import { useState } from "react";
import Grid from "@mui/material/Grid2";
import TravlDataExtractionTable from "./TravlDataExtraction";
import toExtractionRow from "../TRAVL/TravlHelpers/extractToRow"
import { useTravlData } from "./TravlContext";

export default function TRAVL() {
    const { siteData } = useTravlData();
    const [landUse, setLandUse] = useState<string>("All Surveys");

    const extractionRows = siteData
        .filter(f => f.LandUseDesc === landUse || landUse === "All Surveys")
        .map(d => toExtractionRow(d))
        .sort((a, b) => {
            const landUseCmp = a.landUse.localeCompare(b.landUse);
            if (landUseCmp !== 0) return landUseCmp;
            return a.name.localeCompare(b.name);
        });

    return (
        <Grid container>
            {extractionRows.length !== 0 &&
                <TravlDataExtractionTable rows={extractionRows} landUse={landUse} setLandUse={setLandUse} />
            }
        </Grid>

    )
}